import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src902701299/src/pubgen-app/next-app/app/(authenticated)/client.tsx");
